<template>
  <div id="app">
<!--    <CommonHeader v-if="$route.meta.isShowCommonHead"/>-->
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>
<script>
import rematchTask from '@/services/rematchTask'

// import CommonHeader from "@/views/common/header.vue";
export default {
  mounted () {
    rematchTask.resume()
    let href = window.location.href
    let token = href.split("token=")[1]
    if (token) {
      localStorage.setItem("token", token)
    }
  },
  created () {
    // getRole().then(res => {
    //   if (res.code === 200) {
    //     localStorage.setItem("info", JSON.stringify(res.rows[0]))
    //   } else {
    //     localStorage.setItem("info", undefined)
    //   }

    // })
    // this.$api.projectUserRole().then(res => {
    //   if (res.code === 200) {
    //     localStorage.setItem("userRole", JSON.stringify(res.data.userRole))
    //     console.log(res)
    //   }
    // })
  }
}
</script>
<style lang="scss">
html {
  overflow-y: scroll; // 强制显示滚动条，防止布局抖动
  scrollbar-gutter: stable; // 预留滚动条空间（如果浏览器支持）
}

body {
  /* 与首页设计一致：从头部到底部统一渐变；正文字号与首页一致（14px 级由组件控制） */
  background: linear-gradient(45deg, #F8FAFC 0%, #EFF6FF 50%, #F1F5F9 100%);
  min-height: 100vh;
  color: #1a1a2e;
  font-size: 16px;
}

:global(.el-table) {
  width: 100%;
}

:global(.el-table__body-wrapper) {
  width: 100%;
}
</style>
